import BaseAuthAdapter from 'register-partners-js/adapters/base/auth';
import { authBaseURL, authNamespace } from 'register-partners-js/constants/hosts';

export default class UserAdapter extends BaseAuthAdapter {
  host = authBaseURL;
  namespace = authNamespace;

  urlForQueryRecord() {
    return `${this.host}/${this.namespace}/users/me`;
  }
}
